(function ($) {
    'use strict';

    var prfx = 'acom';

    acom_app.views.Styles = Backbone.View.extend({
        el: 'head',
        wrapper: '#acom-styles',
        template: _.template($("#" + prfx + "-styles-template").html()),
        initialize: function () {
            this.settings = acom_app.models.settings

        },
        render: function () {
            this.close();

            var html = this.template(this.settings.toJSON());
            this.$el.append(html);

            return this;
        },
        close: function () {
            $(this.wrapper).remove();
            this.unbind();
        }
    })
})(jQuery)